"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var app_1 = require("../app");
var useContext = react_1.default.useContext;
exports.default = (function (_a) {
    var shippingRates = _a.shippingRates;
    var context = useContext(app_1.CheckoutContext);
    if (!context)
        return null;
    var shippingMethod = context.shippingMethod, setShippingMethod = context.setShippingMethod, shippingMethodSubtext = context.shippingMethodSubtext;
    var saveShippingSpeed = function (selectedRate) {
        if (selectedRate === void 0) { selectedRate = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedRate) return [3 /*break*/, 2];
                        return [4 /*yield*/, setShippingMethod(selectedRate)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    // Return the shipping subtext from theme settings Cart -> Shipping SubText
    var shippingSubText = function (method) {
        var cleanMethod = decodeURIComponent(method);
        var lookup = cleanMethod.toLowerCase().split('-')[1];
        return typeof shippingMethodSubtext === 'undefined' ? '' : shippingMethodSubtext[lookup];
    };
    if (!shippingMethod && shippingRates.length >= 1) {
        // get the shipping rate with the lowest rate and set it as the default
        var lowestShippingRate = shippingRates.reduce(function (acc, curr) {
            return Number(curr.price) < Number(acc.price) ? curr : acc;
        }, shippingRates[0]);
        saveShippingSpeed(lowestShippingRate);
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h4", { className: 'h4 margin-bottom-6' }, "Delivery Method"),
        react_1.default.createElement("div", { className: 'checkout-delivery-methods-container' }, shippingRates.map(function (rate, idx) { return (react_1.default.createElement("div", { className: 'checkout-shipping-method', key: rate.handle },
            react_1.default.createElement("input", { type: 'radio', name: "shipping_rate_".concat(idx), value: rate.handle, id: rate.handle, checked: rate.handle === (shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.handle), onChange: function () { return saveShippingSpeed(rate); } }),
            react_1.default.createElement("label", { className: 'font-lighter', htmlFor: rate.handle },
                react_1.default.createElement("div", null, rate.name),
                shippingSubText(rate.handle)),
            react_1.default.createElement("div", { className: 'display-inline-block float-right' }, rate.price === '0.00' ? 'FREE' : "$".concat(rate.price)))); }))));
});
